import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import AddHomeWorkIcon from "@mui/icons-material/AddHomeWork";
import { PropertyList } from "../features/properties/components/PropertyList";
import { AddPropertyModal } from "../features/properties/components/AddPropertyModal";
import { PropertyFilters } from "../features/properties/components/PropertyFilters";

export const PropertiesPage: React.FC = () => {
  const [isAddModalOpen, setIsAddModalOpen] = React.useState(false);

  const handleOpenAddModal = () => setIsAddModalOpen(true);
  const handleCloseAddModal = () => setIsAddModalOpen(false);

  return (
    <Container
      maxWidth="xl"
      sx={{
        pt: 2,
        minHeight: "calc(100vh - 64px)", // Same as DocumentsPage
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          flex: 1,
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Box>
            <Typography variant="h4" component="h1" gutterBottom>
              Properties
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Manage your properties and their associated documents.
            </Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<AddHomeWorkIcon />}
            onClick={handleOpenAddModal}
            data-testid="add-property-button"
          >
            Add Property
          </Button>
        </Box>

        <PropertyFilters />
        <PropertyList />
      </Box>

      <AddPropertyModal open={isAddModalOpen} onClose={handleCloseAddModal} />
    </Container>
  );
};
